export default "__VITE_ASSET__8XLtIrDW__"